import { Component, OnInit } from '@angular/core';
import { NewsService } from '../../core/services/news.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'News',
    },
  ];

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 4;
  searchValue = '';
  exceededLimit= false;

  constructor(
    private newService: NewsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadNews();
  }

  loadNews(): void {
    this.newService
      .getNews(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  getNewsBySearch(): void {
    this.newService
      .getNewsBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  onCurrentPageDataChange(page: any): void {
    this.currentPage = page;
    this.loadNews();
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.loadNews();
  }

  viewNews(id: any): void {
    this.router.navigate(['/admin/single-news/', { id }]);
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }


  serializeToHTML(children: any[]): string {
    const result = children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let truncatedText = node.text.length > 250 ? `${node.text.slice(0, 250)}...` : node.text;
          let text = `<span>${this.escapeHTML(truncatedText)}</span>`;

          if (node.bold) {
            text = `${text}`;
          }

          if (node.code) {
            text = `${text}`;
          }

          if (node.italic) {
            text = `${text}`;
          }

          if (node.underline) {
            text = `${text}`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h2':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h3':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h4':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h5':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'h6':
            return `<p>${this.serializeToHTML(node.children)}</p>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<a>${this.serializeToHTML(
              node.children
            )}</a>`;

          default:
            return `<p class="my-4 font-[400]">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');

    // Truncate the result to 250 characters
    return result.length > 250 ? `${result.slice(0, 250)}...` : result;
  }


  private escapeHTML(text: string): string {
    return text;
  }

}
